import { createContext } from 'react'

export const TopbarContext = createContext(null)
